$(document).ready(function () {
    $('#inputSoggetto').on('input', function () {
        const nominativo = $(this).val();
        cercaDebitore(nominativo);
    });

    const cercaDebitore = _.debounce(function (nominativo) {
        $.ajax({
            url: '/crisisovraindebitamento/debitoreAjax',
            type: 'GET',
            data: {search: nominativo},
            success: function (response) {
                updateView(response);
                showNoResultsMessage('categoria_table_1');
                showNoResultsMessage('categoria_table_2');
            },
            error: function (error) {
                console.error('Errore durante la richiesta AJAX:', error);
            }
        });
    }, 500);

    function updateView(data) {
        $('#categoria_table_1 tbody').empty();
        $('#categoria_table_2 tbody').empty();

        $.each(data, function (index, crisi) {
            let row = '<tr><td>' + crisi.titolo + '</td><td>';

            $.each(crisi.files, function (fileIndex, file) {
                row += '<a style="text-decoration: none; display: block;" href="/file-crisi/' + file.id + '/show"><img alt="" src="/docs/pagine/icone/pdf-icon.png"><span>&nbsp;' + file.titolo_file + '</span></a>';
            });

            row += '</td></tr>';
            $('#categoria_table_' + crisi.categoria).append(row);
        });
    }

    function showNoResultsMessage(tableId) {
        const tableBody = $('#' + tableId + ' tbody');
        if (tableBody.children().length === 0) {
            tableBody.append('<tr><td colspan="2" class="text-center color-red">Nessun risultato trovato</td></tr>');
        }
    }
});
